import { watchOnce } from '@vueuse/core';
import { useMobileNav } from '../useMobileNav';

export default function useMenuWithAccount() {
  const { openNav, setMode, isMenuOpened, isMenuHydrated } = useMobileNav();
  const openAccountSubcategory = () => setMode({ id: 'accountContent', title: '', animate: false }, true);
  const openMenuWithAccount = () => {
    openNav({ isAccountSubcategoryOpened: true });

    if (isMenuHydrated.value) {
      openAccountSubcategory();
      return;
    }

    watchOnce(isMenuHydrated, () => {
      if (isMenuOpened.value) {
        openAccountSubcategory();
      }
    });
  };

  return { openMenuWithAccount };
}
